import { useEffect, useMemo } from 'react';
import { connect, useDispatch } from 'react-redux';

import styles from './KnmLateFieldsRemark.module.scss';
import { IRootState } from '../../../CorePackage/MainModule/interfaces/IRootState';
import { getKnmDataLateChangesFieldLinks, getKnmDataLateChangesFields } from '../../MainModule/selectors/knmSelectors';
import { IKnmHistoryItem } from '../../../APIPackage/KnmModule/interfaces/IKnmHistoryItem';
import { getLateFiledText } from './common/getLateFiledText';
import { setKnmLateChangesFieldLinks } from '../../MainModule/actions/knmActions';

interface IKnmLateFieldsRemarkProps {
  isLeftPosition?: boolean;
  fieldId?: string;
  lateFieldPath: string;
}

interface IKnmLateFieldsRemarkStoreProps {
  lateChangesFields: IKnmHistoryItem[] | null | undefined;
  lateChangesFieldLinks: Map<string, string>;
}

const KnmLateFieldsRemarkWithoutStore = ({
  isLeftPosition,
  fieldId,
  lateFieldPath,
  lateChangesFields,
  lateChangesFieldLinks,
}: IKnmLateFieldsRemarkProps & IKnmLateFieldsRemarkStoreProps) => {
  if (!lateChangesFields) {
    return null;
  }

  const dispatch = useDispatch();

  const lateFiledText = useMemo(() => {
    return getLateFiledText(lateChangesFields, lateFieldPath);
  }, [lateChangesFields, lateFieldPath]);

  if (!lateFiledText) {
    return null;
  }

  useEffect(() => {
    if (fieldId) {
      lateChangesFieldLinks.set(fieldId, lateFieldPath);
      dispatch(setKnmLateChangesFieldLinks(lateChangesFieldLinks));
    }
  }, [dispatch, fieldId, lateFieldPath]);

  return (
    <div className={styles.LateFieldsRemark}>
      <span className={styles.Icon}></span>
      <div className={isLeftPosition ? styles.ChangesBlockLeftPosition : styles.ChangesBlock}>
        <div className={styles.ChangesBlockContent}>{lateFiledText}</div>
      </div>
    </div>
  );
};

const mapStateToProps = (state: IRootState): IKnmLateFieldsRemarkStoreProps => ({
  lateChangesFields: getKnmDataLateChangesFields(state),
  lateChangesFieldLinks: getKnmDataLateChangesFieldLinks(state),
});

export const KnmLateFieldsRemark = connect(mapStateToProps)(KnmLateFieldsRemarkWithoutStore);
